import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import { DadosRestaurante } from '../Components/CardRestaurants'

export type Product = {
    id: number
    price: number
}
  
export type PurchasePayload = {
    products: Product[]
    delivery: {
    receiver: string
    adress: {
        description: string
        city: string
        zipCode: string
        number: number
        complement?: string
    }
    }
    payment: {
    card: {
        name: string
        number: string
        code: number
        expires: {
        month: number
        year: number
        }
    }
    }
}

const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://fake-api-tau.vercel.app/api/efood',
    }),
    endpoints: (builder) => ({
        getRestaurants: builder.query<DadosRestaurante[], void>({
            query: () => 'restaurantes'
        }),
        getCurrentRest: builder.query<DadosRestaurante, string>({
            query: (id) => `restaurantes/${id}`
        }),
        purchase: builder.mutation<any, PurchasePayload>({
            query: (body) => ({
              url: 'checkout',
              method: 'POST',
              body
            })
    })
})})

export const {useGetRestaurantsQuery, useGetCurrentRestQuery, usePurchaseMutation} = api

export default api